<template>
  <main class="f-row full app-wrapper">
    <Side />
    <div class="f-col full">
      <Header />
      <Body />
      <Footer />
    </div>
    <Modal v-if="displayModal" />
    <Notification />
  </main>
</template>

<script>
import { loadIcons } from "../config/icons";

import Header from "./layout/Header.vue";
import Side from "./layout/Side.vue";
import Body from "./layout/Body.vue";
import Footer from "./layout/Footer.vue";
import Modal from "./library/Modal";
import Notification from "./library/Notification";

export default {
  name: "App",
  components: {
    Header,
    Side,
    Body,
    Footer,
    Modal,
    Notification,
  },
  computed: {
    displayModal() {
      return this.$store.state.modal.display;
    },
  },
  beforeCreate() {
    loadIcons();
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");
@import url("https://fonts.googleapis.com/css?family=Montserrat|Open+Sans&display=swap");

:root {
  --primary-color: #159ad1;
  --primary-font-color: #fff;
}

* {
  font-family: "Open Sans", sans-serif;
  /* font-family: "Montserrat", sans-serif; */
}

html {
  min-height: 100%;
  position: relative;
}

body {
  height: 100%;
  background-color: #f2f4f3;
  margin: 0;
}

a {
  cursor: pointer;
  border: none;
  color: inherit;
  text-decoration: inherit;
}

a:link {
  color: inherit;
  text-decoration: inherit;
}

a:visited {
  color: inherit;
  text-decoration: inherit;
}

a:hover {
  color: inherit;
  text-decoration: inherit;
}

a:active {
  color: inherit;
  text-decoration: inherit;
}

a:focus {
  outline: none;
}

input {
  background-image: none;
  border: 0;
  color: #444;
  font: inherit;
  margin: 0;
  outline: 0;
  padding: 0;
  transition: background-color 0.3s;
}

button {
  cursor: pointer;
  border: none;
  color: inherit;
  background-color: inherit;
  text-decoration: inherit;
}

button:focus {
  outline: none;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #ccc;
  opacity: 0;
}

::-webkit-scrollbar-thumb {
  background: #4e5e6e;
}

.hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.f-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.f-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ctr {
  align-items: center;
  justify-content: center;
}

.full {
  width: 100%;
  height: 100%;
}

.app-wrapper {
  justify-content: space-between;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 0;
}

.main-section {
  height: 100%;
  width: 100%;
}
</style>
